import { Component, OnInit, ElementRef, } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import { DrawCollapseService } from '@shared/core/directives/drawCollapse';
import { ISubNavPage } from '@shared/core/components/subNav';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-account-draw-menu',
    templateUrl: './account-draw-menu.shared.component.html',
    styleUrls: ['./account-draw-menu.shared.component.scss']
})
export class AccountDrawMenuComponent implements OnInit {
    public pages$: Observable<ISubNavPage[]>;
    public activePageId$: Observable<number>;

    constructor(
        public controllers: Controllers,
        public elementRef: ElementRef,
    ) { }

    ngOnInit(): void {
        this.pages$ = this.controllers.routes.accountPages$();
        this.activePageId$ = this.controllers.routes.mapAccountRouteUrlToId$();
    }

    public handlePageClick($event: ISubNavPage): void {
        /* No need to hadnle that - jus pass scroll = false to draw-bar-menu and it will automaticaly nav you to proper page */
    }

    public get relativeTarget(): HTMLElement {
        return this.elementRef?.nativeElement;
    }

    // public handleSearchToggle($event: boolean): void {
    //     if (this.isMobile) {
    //         if (this._isOpen) {
    //             this.drawCollapseService.toggleDraw(false);
    //             setTimeout(() => {
    //                 this.subNavService.forceHeightUpdate();
    //             }, 500);
    //         } else {
    //             this.drawCollapseService.toggleDraw(true);
    //         }
    //     }
    // }
}
